import Vue from "vue";

import App from "./App";
import router from "./router";
import VModal from "vue-js-modal";
import VueAnalytics from "vue-analytics";

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: "UA-706766-6", // ALS
  disabled: true, // user has to say it's ok first, or we discover it's a country without a cookie law
  router
});

Vue.use(VModal);

require("es6-object-assign/auto"); // for IE11 when use vue-js-modal

new Vue({
  el: "#app",
  data: {
    config: Vue.config
  },
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js